/* =====================================================================
   VEYRASOIR — interacciones (vanilla JS, sin librerías)
   Cada init comprueba si su elemento existe, así el archivo sirve en
   todas las páginas. Respeta prefers-reduced-motion.
   ===================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveal al hacer scroll (un solo observer compartido) ---- */
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('mt-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Contadores animados (count-up) ---- */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute('data-mt-count'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-count'));
        var decimals = (el.getAttribute('data-mt-decimals') | 0);
        var suffix = el.getAttribute('data-mt-suffix') || '';
        var prefix = el.getAttribute('data-mt-prefix') || '';
        var dur = 1500, start = null;
        function step(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = prefix + target.toFixed(decimals) + suffix;
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---- Parallax suave (transform con scroll) ---- */
  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var center = r.top + r.height / 2;
        var off = (center - vh / 2) / vh;      // -1..1 aprox
        var amt = parseFloat(el.getAttribute('data-mt-parallax')) || 20;
        el.style.transform = 'translate3d(0,' + (off * amt).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---- Acordeón (FAQ / detalles) ---- */
  function initAccordion() {
    var items = document.querySelectorAll('[data-mt-accordion] .mt-acc__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var head = item.querySelector('.mt-acc__head');
      if (!head) return;
      head.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        var group = item.closest('[data-mt-accordion]');
        if (group && group.getAttribute('data-mt-single') === 'true') {
          group.querySelectorAll('.mt-acc__item.is-open').forEach(function (o) {
            if (o !== item) { o.classList.remove('is-open'); }
          });
        }
        item.classList.toggle('is-open', !open);
      });
    });
  }

  /* ---- Comparador antes/después con deslizador ---- */
  function initCompare() {
    var comps = document.querySelectorAll('[data-mt-compare]');
    if (!comps.length) return;
    comps.forEach(function (c) {
      var range = c.querySelector('.mt-compare__range');
      var top = c.querySelector('.mt-compare__top');
      var handle = c.querySelector('.mt-compare__handle');
      if (!range || !top) return;
      function set(v) {
        top.style.width = v + '%';
        if (handle) handle.style.left = v + '%';
      }
      range.addEventListener('input', function () { set(this.value); });
      set(range.value || 50);
    });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var gal = document.querySelector('[data-mt-gallery]');
    if (!gal) return;
    var mains = gal.querySelectorAll('[data-mt-slide]');
    var thumbs = gal.querySelectorAll('[data-mt-thumb]');
    var prev = gal.querySelector('[data-mt-prev]');
    var next = gal.querySelector('[data-mt-next]');
    if (!mains.length) return;
    var count = mains.length;
    var cur = 0;
    function show(i) {
      i = ((i % count) + count) % count; // vuelta circular
      cur = i;
      mains.forEach(function (m) {
        var on = +m.getAttribute('data-mt-slide') === i;
        m.classList.toggle('is-active', on);
        if (on) { m.removeAttribute('hidden'); } else { m.setAttribute('hidden', ''); }
      });
      thumbs.forEach(function (t) {
        t.classList.toggle('is-active', +t.getAttribute('data-mt-thumb') === i);
      });
      gal.classList.toggle('mt-not-first', i !== 0);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(+this.getAttribute('data-mt-thumb')); });
    });
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    // Deslizar con el dedo (móvil)
    var stage = gal.querySelector('.mt-pdp__stage');
    if (stage) {
      var x0 = null;
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) { show(dx < 0 ? cur + 1 : cur - 1); }
        x0 = null;
      }, { passive: true });
    }
    show(0);
  }

  /* ---- Página de producto: variantes ---- */
  function initProducto() {
    var form = document.querySelector('.mt-pdp__form');
    if (!form) return;
    var dataEl = form.querySelector('[data-mt-variants]');
    var idInput = form.querySelector('[data-mt-variant-id]');
    if (!dataEl || !idInput) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var priceNow = document.querySelector('[data-mt-price-now]');
    var priceWas = document.querySelector('[data-mt-price-was]');
    var addBtn = form.querySelector('[data-mt-add]');
    var addText = form.querySelector('[data-mt-add-text]');
    var soldOut = (addBtn && addBtn.getAttribute('data-sold-text')) || 'Épuisé';
    var addLabel = (addText && addText.textContent) || 'Ajouter au panier';

    function money(cents) {
      // Igual formato que el filtro money de la tienda (p. ej. "€58,95")
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    }
    function selectedValues() {
      var checked = form.querySelectorAll('input[name^="option-"]:checked');
      return Array.prototype.map.call(checked, function (i) { return i.value; });
    }
    function findVariant(vals) {
      return variants.find(function (v) {
        return (v.options || []).every(function (opt, i) { return opt === vals[i]; });
      });
    }
    var stockEl = document.querySelector('[data-mt-stock]');
    function update() {
      var vals = selectedValues();
      var v = vals.length ? findVariant(vals) : variants[0];
      if (!v) return;
      idInput.value = v.id;
      // Precio por bote cuando la oferta tiene más de 1 unidad (evita el "susto" del total)
      var qty = parseInt(v.title, 10) || 1;
      var unitSuffix = (priceNow && priceNow.getAttribute('data-unit-suffix')) || '';
      var nowVal = qty > 1 ? Math.round(v.price / qty) : v.price;
      var wasVal = v.compare_at_price ? (qty > 1 ? Math.round(v.compare_at_price / qty) : v.compare_at_price) : 0;
      if (priceNow) priceNow.textContent = money(nowVal) + (qty > 1 && unitSuffix ? ' ' + unitSuffix : '');
      if (priceWas) {
        if (wasVal && wasVal > nowVal) {
          priceWas.textContent = money(wasVal); priceWas.style.display = '';
        } else { priceWas.style.display = 'none'; }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addText) addText.textContent = v.available ? addLabel : soldOut;
      }
      if (stockEl) {
        var thr = parseInt(stockEl.getAttribute('data-threshold'), 10) || 10;
        var q = (typeof v.inventory_quantity === 'number') ? v.inventory_quantity : null;
        var nEl = stockEl.querySelector('[data-mt-stock-n]');
        if (q !== null && v.available && q > 0 && q <= thr && nEl) {
          nEl.textContent = q;
          stockEl.hidden = false;
        } else {
          stockEl.hidden = true;
        }
      }
    }
    form.querySelectorAll('.mt-offer input, .mt-pdp__pill input').forEach(function (input) {
      input.addEventListener('change', function () {
        form.querySelectorAll('.mt-offer, .mt-pdp__pill').forEach(function (el) { el.classList.remove('is-active'); });
        var lab = this.closest('.mt-offer, .mt-pdp__pill');
        if (lab) lab.classList.add('is-active');
        update();
      });
    });
    update();

    // Fix carrito: en este tema (sin cart-drawer) el submit nativo no añadía al
    // carrito de forma fiable. Interceptamos, añadimos por fetch y vamos al checkout.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = idInput.value;
      if (!id) return;
      if (addBtn) addBtn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { return r.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function () { if (addBtn) addBtn.disabled = false; window.location.href = '/cart'; });
    }, true);

    /* ---- Barra fija de compra en móvil ---- */
    var sticky = document.querySelector('[data-mt-sticky]');
    if (sticky && addBtn) {
      var sPrice = sticky.querySelector('[data-mt-sticky-price]');
      var sBtn = sticky.querySelector('[data-mt-sticky-add]');
      var syncSticky = function () {
        if (sPrice && priceNow) sPrice.textContent = priceNow.textContent;
        if (sBtn) {
          sBtn.disabled = addBtn.disabled;
          if (addText) sBtn.textContent = addText.textContent;
        }
      };
      if (sBtn) sBtn.addEventListener('click', function () { addBtn.click(); });
      form.querySelectorAll('.mt-offer input, .mt-pdp__pill input').forEach(function (input) {
        input.addEventListener('change', function () { setTimeout(syncSticky, 0); });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
        }).observe(addBtn);
      } else {
        sticky.classList.add('is-visible');
      }
      syncSticky();
    }
  }

  /* ---- Corte de las 14h (hora de París) ---- */
  function initCutoff() {
    var cut = document.querySelector('[data-mt-cutoff]');
    if (!cut) return;
    var before = cut.getAttribute('data-before') || '';
    var after = cut.getAttribute('data-after') || '';
    var txt = before;
    try {
      var h = parseInt(new Intl.DateTimeFormat('fr-FR', { hour: 'numeric', hour12: false, timeZone: 'Europe/Paris' }).format(new Date()), 10);
      txt = (h < 14) ? before : after;
    } catch (e) { /* si el navegador no soporta timeZone, usa el texto de antes de las 14h */ }
    if (txt) { cut.textContent = txt; cut.hidden = false; }
  }

  function boot() {
    initReveal();
    initCounters();
    initParallax();
    initAccordion();
    initCompare();
    initGallery();
    initProducto();
    initCutoff();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
